import * as React from 'react';
import styled from 'styled-components';

import { Show } from 'src/components/condition';
import { Utility } from 'src/styledComponents/Typography';

import { RacerName } from '../RacerName';

const Wrapper = styled.div<{ grid: string }>`
  display: grid;
  align-items: center;
  grid-template-columns: ${(props) => props.grid};
  gap: 8px;

  padding-left: 40px;
  padding-right: 10px;
  height: 64px;
  width: 100%;

  &:nth-child(even) {
    background-color: ${(props) => props.theme.main.colors.clay7};
  }
`;

const StyledUtility = styled(Utility)`
  color: ${(props) => props.theme.main.colors.clay2};
`;

type Props = {
  value: RacersType;
  withBibs?: boolean;
  bibCellActive?: boolean;
};

export const LeftSideSingleRow: React.FC<Props> = (props) => {
  const { value, withBibs = true, bibCellActive = false } = props;
  const showBibCell = withBibs || bibCellActive;

  const grid = `${showBibCell ? '60px' : ''} 1fr`;

  const bib = withBibs ? value.bib_number : '';

  return (
    <Wrapper grid={grid}>
      <Show if={showBibCell}>
        <StyledUtility variant='u2' weight='medium'>
          {bib}
        </StyledUtility>
      </Show>
      <RacerName value={value} />
    </Wrapper>
  );
};
